import { Component, OnInit, EventEmitter } from '@angular/core';
import { IEditContentComponent } from '@vlemaitre/ngx-cvbsp-author-tool';
import { NgxPlayerVideoData } from '@vlemaitre/ngx-player-video';
import { MatDialog } from '@angular/material/dialog';
import { NgxCvbspUploaderDialogComponent, DialogConfig } from '@vlemaitre/ngx-cvbsp-uploader';
import { NgxPlayerVideoCreateService } from '../ngx-player-video-create.service';
import { Multilang } from 'ngx-cvbsp-player';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngx-player-video-create',
  templateUrl: './ngx-player-video-create.component.html',
  styleUrls: ['./ngx-player-video-create.component.scss']
})
export class NgxPlayerVideoCreateComponent implements OnInit, IEditContentComponent {
  lang: string;
  langApp: string;
  data: NgxPlayerVideoData;
  changeEvent: EventEmitter<NgxPlayerVideoData> = new EventEmitter();
  showAdvancedParameters: boolean;
  constructor(
    public service: NgxPlayerVideoCreateService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.data.intro = this.data.intro ? this.data.intro : { keep: null, fr : 'Votre intro', en: 'This is your intro' };
    this.data.title = this.data.title ? this.data.title : { keep: null, fr : 'Titre', en: 'Title' };
    this.data.videoHeights = this.data.videoHeights ? this.data.videoHeights : { keep: null, fr : '', en: '240' };
    this.data.videoTypes = this.data.videoTypes ? this.data.videoTypes : new Multilang();
    this.data.videoWidths = this.data.videoWidths ? this.data.videoWidths : { keep: null, fr : '100%', en: '100%' };
    this.data.videoUrls = this.data.videoUrls ? this.data.videoUrls : new Multilang();
  }

  inputChange() {
    this.changeEvent.next(this.data);
  }

  openUploaderDialog(replace?: boolean) {
    if (!this.service.urlToUpload) {
      alert('you need to add an url to upload video in the config of the module, check the readme');
      return;
    }
    const dialogRef = this.dialog.open(NgxCvbspUploaderDialogComponent, {
      width: '500px',
      data: {
        restrictedExtensions: ['mp4'],
        closeOnUpload: true,
        urlToUpload: this.service.urlToUpload
      } as unknown as DialogConfig,
    });

    dialogRef.afterClosed().subscribe(this.onUploaded);
  }

  onUploaded = result => {
    if (result) {
      this.data.videoUrls[this.lang] = result.externalUrl;
      this.data.videoTypes[this.lang] = 'video/mp4';
      this.changeEvent.next(this.data);
    }
  }

}
